import gettext from 'gettext.js'
import settings from './settings'
import ru from '../translations/messages.ru'
import en from '../translations/messages.en'
import cn from '../translations/messages.cn'

const i18n = gettext()

i18n.setMessages('messages', 'ru-RU', ru,
  'nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);')
i18n.setMessages('messages', 'en-US', en, 'nplurals=2; plural=(n != 1);')
i18n.setMessages('messages', 'zh-CH', cn, 'nplurals=1; plural=0;')

i18n.textdomain('messages')
i18n.setLocale(settings.LOCALE)

export default i18n
